import React, { Component } from "react";
import { message } from "antd";
import axios from "axios";
import {
  ModalItem,
  Form,
  FormItem,
  InputItem,
  ButtonItem,
  ErrorItem
} from "../../../../../Components/Items";

class ModalEditarTutorial extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
  };

  componentDidUpdate(prevProps) {
    // Cuando abres el modal y llega el tutorial → rellenamos form
    if (
      prevProps.visible !== this.props.visible &&
      this.props.visible &&
      this.props.video
    ) {
      this.formRef.current?.setFieldsValue(this.props.video);
    }
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish = (values) => {
    this.setState({ loading: true });

    axios
      .put("tutoriales/editarTutorial", {
        _id: this.props.video._id,
        ...values,
      })
      .then(() => {
        this.setState({ loading: false });
        message.success("Tutorial actualizado correctamente");
        this.cerrar();
        this.props.recargar();
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al actualizar el tutorial");
      });
  };

  cerrar = () => {
    this.props.onClose();
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
  };

  render() {
    return (
      <ModalItem
        title="Editar Tutorial"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrar}
      >
        <Form
          ref={this.formRef}
          name="modalEditarTutorial"
          layout
          bottom={
            <ButtonItem
              type="primary"
              htmlType="submit"
              style={{ display: "block", margin: "0 0 0 auto" }}
              loading={this.state.loading}
            >
              Guardar cambios
            </ButtonItem>
          }
          onFinish={this.onFinish}
          onFinishFailed={this.onFinishFailed}
        >
          <FormItem
            name="titulo"
            label="Título"
            required
            margin
          >
            <InputItem placeholder="Título del tutorial" />
          </FormItem>

          <FormItem
            name="descripcion"
            label="Descripción"
            required
            margin
          >
            <InputItem type="textarea" rows={3} placeholder="Descripción" />
          </FormItem>

          <FormItem
            name="url"
            label="URL del Video"
            required
            margin
          >
            <InputItem placeholder="URL del video (YouTube)" />
          </FormItem>

          <FormItem
            name="duracion"
            label="Duración"
            required
            margin
          >
            <InputItem placeholder="Ej: 12:45" />
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

export default ModalEditarTutorial;
